module.exports = __webpack_public_path__ + "static/media/20210409_194001_810_IMG_0068.60abd9fb.jpg";